import DolphinTradeHubPage from './DolphinTradeHubPage';

export default DolphinTradeHubPage;
